import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

function AddAccountGrouptype() {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const [grouptypes, setGrouptypes] = useState([]);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    subgroup_id: 0,
    group_type_id: "",
    subgroup_name: "",
    sub_group_code: "",
    school_id: userObj?.school_id || "",
  });

  const fetchGroupTypes = async () => {
    try {
      const res = await axios.get(`${baseUrl}/getgrouptypes/`, {
        params: { action: "READ", },
      });
      setGrouptypes(res.data?.group_types || []);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load group types");
    }
  };

  useEffect(() => {
    fetchGroupTypes();
    // eslint-disable-next-line
  }, []);

  // Load edit data
  useEffect(() => {
    if (routeLocation.state?.rowData) {
      const d = routeLocation.state.rowData;
      setEditId(d.subgroup_id);

      setForm({
        subgroup_id: d.subgroup_id || 0,
        group_type_id: d.group_type_id || "",
        subgroup_name: d.subgroup_name || "",
        sub_group_code: d.sub_group_code || "",
        school_id: userObj?.school_id || "",
      });

      window.history.replaceState({}, document.title);
    }
  }, []);

  const selectedGroupTypeName = useMemo(() => {
    const gt = grouptypes.find(
      (g) => Number(g.group_type_id) === Number(form.group_type_id)
    );
    return gt?.group_type_name || "";
  }, [grouptypes, form.group_type_id]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm((p) => ({ ...p, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.group_type_id) return toast.error("Group Type is required");
    if (!form.subgroup_name.trim()) return toast.error("Sub Group Name is required");
    if (!form.sub_group_code.trim()) return toast.error("Sub Group Code is required");

    const payload = {
      subgroup_id: editId ? Number(form.subgroup_id) : 0,
      group_type_id: Number(form.group_type_id),
      subgroup_name: form.subgroup_name.trim(),
      sub_group_code: form.sub_group_code.trim(),
      user: userObj?.user_name ,
      school_id: Number(userObj?.school_id),
    };

    try {
      const res = await axios.post(`${baseUrl}/subgroupmastersave/`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      const first = Array.isArray(res.data) ? res.data[0] : res.data;

      if (first?.status === "SUCCESS") {
        toast.success(editId ? "Updated Successfully" : "Created Successfully");
        handleReset();
        navigate("/finance/account-grouptypes");
      } else {
        toast.error(first?.message || "Failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.error || "Save failed");
    }
  };

  const handleReset = () => {
    setEditId(null);
    setForm({
      subgroup_id: 0,
      group_type_id: "",
      subgroup_name: "",
      sub_group_code: "",
      school_id: userObj?.school_id || "",
    });
  };

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">
                    {editId ? "Edit Account Sub Group" : "Add Account Sub Group"}
                  </h6>
                </Col>
              </Row>

              <Row>
                {/* Group Type Dropdown (exactly like your reference) */}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group controlId="group_type_id">
                      <Form.Label>
                       Parent  Group Type <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Select
                        name="group_type_id"
                        id="group_type_id"
                        value={form.group_type_id}
                        onChange={(e) =>
                          setForm((p) => ({ ...p, group_type_id: e.target.value }))
                        }
                      >
                        <option value="" disabled hidden>
                          Select Group Type
                        </option>
                        {(grouptypes || []).map((gt) => (
                          <option key={gt.group_type_id} value={gt.group_type_id}>
                            {gt.group_type_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </Col>

                {/* Subgroup Name */}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group controlId="subgroup_name">
                      <Form.Label>
                        Sub Group Name <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="subgroup_name"
                        value={form.subgroup_name}
                        placeholder="Enter Sub Group Name"
                        maxLength={200}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </div>
                </Col>

                {/* Subgroup Code */}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group controlId="sub_group_code">
                      <Form.Label>
                        Sub Group Code <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="sub_group_code"
                        value={form.sub_group_code}
                        placeholder="Enter Sub Group Code"
                        maxLength={30}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </div>
                </Col>

              
              </Row>

              <div className="d-flex justify-content-between mt-3">
                <Button
                  type="button"
                  variant="primary"
                  className="btn-info clearBtn"
                  onClick={handleReset}
                >
                  Reset
                </Button>

                <div>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-danger secondaryBtn me-2"
                    onClick={() => window.history.back()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    className="btn-success primaryBtn"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default AddAccountGrouptype;
